export enum DocumentScope {
  workingSiteDocument, companyDocument, companyCommunicationDocument, userDocument
}
